import React from "react";
import "./style.scss";
import { dsnCN } from "../../hooks/helper";

function InfoBox({ className }) {
  return (
    <div className={dsnCN("box-info-contact", className)}>
      <h3>Bring a message from your travels?</h3>
      <p className="mt-10">
        Send word, and I shall answer when the stars allow.
      </p>

      <div className="contact-container mt-30">
        <div>
          <span className="mr-10">Email</span>
          <a
            href="mailto:whisper@mystirien.com"
            target="_blank"
            rel="noreferrer"
          >
            whisper@mystirien.com
          </a>
        </div>
        <div>
          <span className="mr-10">Gmail</span>
          <a href="mailto:mystirien@gmail.com" target="_blank" rel="noreferrer">
            mystirien@gmail.com
          </a>
        </div>
        <div>
          <span className="mr-10">Address</span>
          <a href="/map">
            Along the river that flows backward, where wind chimes ring though
            no wind blows
          </a>
        </div>
      </div>
    </div>
  );
}

export default InfoBox;
